import React from "react";
import BulasikDeterjaniEkstra from "../Components/product/BulasikDeterjaniEkstra";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function BulasikDeterjaniEkstraPage() {
    return (
        <>
            <ProductSEO
                name="Bulaşık Deterjanı (Ekstra)"
                description="Ekstra güçlü formül ile zorlu kir ve yağları kolayca temizler; parlak ve hijyenik sonuçlar."
                slug="bulasikdeterjaniekstra"
                imagePath="assets/images/20-kg/9.webp"
            />
            <PageHeader title={t("BULAŞIK DETERJANI EKSTRA")} />
            <BulasikDeterjaniEkstra />
        </>
    );
}

export default BulasikDeterjaniEkstraPage;